import { PLATFORM_ADMIN_ROLE } from "../constants/authRole";

/**
 * Einzige Rechteauswertung im Frontend — Gegenstück zu `UserContext.HasPermission` im Backend.
 * Geprüft wird exakt; Sammelrechte wie `finance.*` gibt es nicht mehr (der Gruppenschalter im
 * Rolleneditor setzt Einzelrechte). `*` ist der Vollzugriff der Administratorrolle.
 */
export function hasPermissionIn(permissions: readonly string[] | null | undefined, permission: string, role?: string | null): boolean {
  if (role === PLATFORM_ADMIN_ROLE) return true;
  if (!permission) return false;
  const list = permissions ?? [];
  if (list.includes("*")) return true;
  const wanted = permission.toLowerCase();
  return list.some((p) => !!p && p.toLowerCase() === wanted);
}

export function hasAnyPermissionIn(permissions: readonly string[] | null | undefined, wanted: readonly string[], role?: string | null): boolean {
  return wanted.some((p) => hasPermissionIn(permissions, p, role));
}
